const cartContants = {
  CART_DETAILS_STARTED: "CART_DETAILS_STARTED",
  CART_DETAILS_FETCHED: "CART_DETAILS_FETCHED",
  CART_DETAILS_FAILED: "CART_DETAILS_FAILED",
  CART_RESET_ADD_TO_CART_FLAG: "CART_RESET_ADD_TO_CART_FLAG",
  CART_RESET_DISPLAY_CART_FLAG: "CART_RESET_DISPLAY_CART_FLAG",
  CART_RESET_REMOVED_PRODUCT_LIST: "CART_RESET_REMOVED_PRODUCT_LIST",
  CART_ADD_TO_REMOVED_PRODUCT_LIST: "CART_ADD_TO_REMOVED_PRODUCT_LIST",
  CART_DELETE_FROM_REMOVED_PRODUCT_LIST:
    "CART_DELETE_FROM_REMOVED_PRODUCT_LIST",
  CART_RESET_OUT_OF_STOCK_LIST: "CART_RESET_OUT_OF_STOCK_LIST",
  CART_CHECKOUT_STARTED: "CART_CHECKOUT_STARTED",
  CART_CHECKOUT_SUCCESS: "CART_CHECKOUT_SUCCESS",
  CART_CHECKOUT_FAILED: "CART_CHECKOUT_FAILED",
  CART_EDIT_STARTED: "CART_EDIT_STARTED",
  CART_TOGGLE_EDIT_ENTRY: "CART_TOGGLE_EDIT_ENTRY",
  CART_SET_EDIT_ENTRY: "CART_SET_EDIT_ENTRY",
  CART_UPPATE_EDIT_ENTRY_QUANTITY: "CART_UPPATE_EDIT_ENTRY_QUANTITY",
  CART_EDIT_SUCCESSFULL: "CART_EDIT_SUCCESSFULL",
  CART_EDIT_FAILED: "CART_EDIT_FAILED",
  CART_SET_EDIT_ENTRY_ERROR: "CART_SET_EDIT_ENTRY_ERROR",
  CART_RESET_ERROR: "CART_RESET_ERROR",
}

export default cartContants
